
import Vue, { PropType } from 'vue';

export function makeWhiskerLine(start: number, end: number, height: number) {
  return `M${[start, -0.4 * height]}
      l${[0, height * 0.8]}
      m${[0, -0.4 * height]}
      L${[end, 0]}`;
}

export interface BoxData {
  whiskers: {
    start: number;
    end: number;
    height: number;
    text: string;
  }[];
  lines: {
    x1: number;
    x2: number;
    stroke: string;
    text: string;
    height: number;
  }[];
  circles: {
    cx: number;
    value: number;
  }[];
}

export default Vue.extend({
  props: {
    data: {
      type: Object as PropType<BoxData>,
      required: true,
    },
  },
  methods: { makeWhiskerLine },
});
